export default (value: number) => {
    if (value === null || value === undefined) {
        return '0';
    }
    return value.toLocaleString('en-GB');
}
